import { writable, derived } from 'svelte/store';

//currently section is not used
export const sectionId = writable(0); //no section is numeric 0
export const sectionTitle = writable("");
export const sectionDescription = writable("");

export const listId = writable(0); //no list is numeric 0
export const listTitle = writable("");
export const listDescription = writable("");
export const followingArray = writable(['readingemailnewsletter','cspanwordforword','stormlaketimes', 'pressrun', 'numlock', 'restofworld']);
// used by List.svelte, updated by FollowingButton.svelte
export const listQuery = derived([listId,followingArray], 
  ([$listId, $followingArray]) => $listId==0 ? $followingArray : $listId )


export const newsletterId = writable(0); //no newsletter is numeric 0
export const newsletterTitle = writable("");
export const newsletterDescription = writable("");




export const whenLast = writable(0);
// export const unreadCount = writable(0);
// export const newCount = writable(0);
export const isDisplayIssue = writable(false);
